module.exports = __webpack_public_path__ + "img/t-3.251b8f32.jpg";